export default "__VITE_ASSET__ebcb3469__"